import { BudgetStatsCard } from "../cards/BudgetStatsCard";

interface RevenueStatsSectionProps {
  validatedAmount: number;
  averageDaily: number;
  transactionCount: number;
  growthRate: number;
  currency: string;
}

export const RevenueStatsSection = ({
  validatedAmount,
  averageDaily,
  transactionCount,
  growthRate,
  currency,
}: RevenueStatsSectionProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <BudgetStatsCard
        title="Chiffre d'affaires validé (Mois en cours)"
        amount={validatedAmount}
        currency={currency}
        growthRate={growthRate}
        className="bg-gradient-to-br from-indigo-500 to-indigo-600"
      />
      
      <BudgetStatsCard
        title="Moyenne Journalière"
        amount={averageDaily}
        currency={currency}
        className="bg-gradient-to-br from-emerald-500 to-emerald-600"
      />

      <BudgetStatsCard
        title="Transactions"
        amount={transactionCount}
        currency={currency}
        className="bg-gradient-to-br from-purple-500 to-purple-600"
      />
    </div>
  );
};